import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { filter, map } from 'ramda';

import { ExternalLink, Menu, MenuLabel, MenuContent, MenuItem } from '../../../../../components';
import flagES from '../../../../../assets/flags/es.png';
import flagFR from '../../../../../assets/flags/fr.png';
import config from '../../../../../config';
import { navigateToLocalization } from '../../../../../util/medianBridge';
import { medianLocalizationRules } from '../../../../../util/medianBridgeConfig';
import { isMedian } from '../../../../../util/median';

import css from './LocalizationMenu.css';

const flagsByLocalization = {
  fr: flagFR,
  es: flagES,
};

const LocalizationMenu = (props) => {
  const { className, intl } = props;
  const supportedLocalization = map(
    ({ localization, link }) => ({
      localization,
      flag: flagsByLocalization[localization],
      link,
    }),
    medianLocalizationRules
  );

  const currentLocalization =
    filter(
      (localization) => localization.localization === config.locale,
      supportedLocalization
    )[0] || supportedLocalization[0];

  const localizationToDisplay = filter(
    (localization) => localization.localization !== currentLocalization.localization,
    supportedLocalization
  );

  const handleLocalizationClick = (event, localization) => {
    if (!isMedian()) {
      return;
    }

    event.preventDefault();
    navigateToLocalization({
      localization,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
    });
  };

  const menuItems = map((localization) => {
    const countryText = intl.formatMessage({
      id: `LocalizationMenu.${localization.localization}Country`,
    });

    return (
      <MenuItem key={`${localization.localization}localization`}>
        <ExternalLink
          href={localization.link}
          className={css.localizationLink}
          onClick={(event) => handleLocalizationClick(event, localization.localization)}
        >
          <span className={css.menuItemBorder} />
          <img
            src={localization.flag}
            className={css.localizationFlag}
            alt={intl.formatMessage({ id: 'LocalizationMenu.flagIcon' })}
          />
          <div className={css.localizationInfo}>
            <FormattedMessage id={`LocalizationMenu.${localization.localization}Localization`} />
            <span className={css.countryText}>{countryText}</span>
          </div>
        </ExternalLink>
      </MenuItem>
    );
  }, localizationToDisplay);

  return (
    <Menu className={className}>
      <MenuLabel className={css.menuLabelDesktop} isOpenClassName={css.menuIsOpen}>
        <img
          src={currentLocalization.flag}
          className={css.currentLocalizationFlag}
          alt={intl.formatMessage({ id: 'LocalizationMenu.currentLocalizationFlag' })}
        />
      </MenuLabel>
      <MenuContent className={css.menuContent}>{menuItems}</MenuContent>
    </Menu>
  );
};

LocalizationMenu.propTypes = {
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(LocalizationMenu);
